// extracted by mini-css-extract-plugin
module.exports = {"cuisineCard":"Directory_cuisineCard__UPZig","crowd":"Directory_crowd__9kno1","captionText":"Directory_captionText__ZUNsb"};